module.exports = __webpack_public_path__ + "public/img/tiku_cbg5.0aa51865.png";